"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldRadio = exports.radioPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _uuid = require("uuid");

var _fieldUtils = require("./fieldUtils");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var radioPropTypes = {
  children: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  val: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]).isRequired,
  isChecked: _propTypes.default.bool,
  handleChange: _propTypes.default.func
};
/**
 * react-a11y is upset about the onClick on a div:
 * You have a click handler on a non-interactive element but no `tabIndex` DOM property.
 * The element will not be navigable or interactive by keyboard users.
 * See 'http://www.w3.org/TR/wai-aria-practices/#focus_tabindex' for more info. div
 * THIS IS A LIE.. this IS keyboard navigable.. TODO: fix config/submit issue?
 */

exports.radioPropTypes = radioPropTypes;

var FieldRadio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FieldRadio, _React$Component);

  function FieldRadio(props) {
    var _this;

    _classCallCheck(this, FieldRadio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FieldRadio).call(this, props));
    var _this$props = _this.props,
        name = _this$props.name,
        val = _this$props.val;
    _this.state = {
      isFocused: false,
      value: _typeof(_this.props.children) === 'object' ? _this.props.val : _this.props.children
    }; // uuid created for case when val or children the same for different element

    _this.uuid = (0, _uuid.v4)();
    _this.fieldIds = (0, _fieldUtils.getAllFieldElementIds)("".concat(name, "-").concat(val));
    _this.inputId = _this.fieldIds.input.id;
    _this.setWrapperRef = _this.setWrapperRef.bind(_assertThisInitialized(_this));
    _this.setIsFocused = _this.setIsFocused.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.containerProps = _this.containerProps.bind(_assertThisInitialized(_this));
    _this.fieldProps = _this.fieldProps.bind(_assertThisInitialized(_this));
    _this.labelProps = _this.labelProps.bind(_assertThisInitialized(_this));
    _this.updateField = _this.updateField.bind(_assertThisInitialized(_this));
    _this.refCallback = _this.refCallback.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FieldRadio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocus();
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: "setIsFocused",
    value: function setIsFocused(bool) {
      this.setState({
        isFocused: bool
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "refCallback",
    value: function refCallback(element) {
      if (element) {
        element.style.fontWeight = 'bold';
        element.style.minWidth = "".concat(element.getBoundingClientRect().width, "px");
        element.style.fontWeight = '';
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var doFocus = this.props.doFocus;
      (0, _utils.focusHandler)(this.wrapperRef, doFocus);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var isChecked = this.props.isChecked;
      /* onClick : document.activeElement = <body>
       * manually focus the input for keyboard nav after clicking
       * should clicking on these have a visual indication of
       * :focus? or just when tabbing?
      */

      var inputElement = document.getElementById(this.inputId);
      if (inputElement) inputElement.focus();
      /* This is a work-around alternative to calling 'event.preventDefault()'
       * on this (when a redux-form Field). If field is already checked we assume the
       * value is not changing so we can just ignore it.
       * This silently deactivates this input value.
       */

      if (!isChecked) {
        this.updateField();
      }
    }
  }, {
    key: "updateField",
    value: function updateField() {
      var _this$props2 = this.props,
          val = _this$props2.val,
          handleChange = _this$props2.handleChange;
      handleChange(val);
    }
  }, {
    key: "containerProps",
    value: function containerProps() {
      var _this2 = this;

      var _this$props3 = this.props,
          cssClass = _this$props3.cssClass,
          isChecked = _this$props3.isChecked;
      var isFocused = this.state.isFocused;
      var containerProps = {
        onClick: function onClick() {
          return _this2.handleClick();
        }
      };

      if (cssClass || isFocused) {
        var _classNames;

        containerProps.className = (0, _dedupe.default)((_classNames = {}, _defineProperty(_classNames, "".concat(cssClass), cssClass), _defineProperty(_classNames, "".concat(cssClass, "--selected"), cssClass && isChecked), _defineProperty(_classNames, 'radio-focused', isFocused), _classNames));
      }

      return containerProps;
    }
  }, {
    key: "labelProps",
    value: function labelProps() {
      return {
        id: this.fieldIds.label.id,
        htmlFor: this.fieldIds.input.id
      };
    }
  }, {
    key: "fieldProps",
    value: function fieldProps() {
      var _this3 = this;

      var _this$props4 = this.props,
          name = _this$props4.name,
          val = _this$props4.val,
          isChecked = _this$props4.isChecked;
      return {
        id: this.inputId,
        value: val,
        type: 'radio',
        name: name,
        checked: isChecked,
        onChange: function onChange() {
          return _this3.updateField();
        },
        onFocus: function onFocus() {
          return _this3.setIsFocused(true);
        },
        onBlur: function onBlur() {
          return _this3.setIsFocused(false);
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint jsx-a11y/label-has-for: 0 */
      var _this$props5 = this.props,
          children = _this$props5.children,
          val = _this$props5.val,
          optionalNode = _this$props5.optionalNode;
      return _react.default.createElement("div", _extends({
        key: this.uuid + this.state.value,
        ref: this.refCallback
      }, this.containerProps()), _react.default.createElement("input", _extends({
        ref: this.setWrapperRef
      }, this.fieldProps())), optionalNode, _react.default.createElement("label", this.labelProps(), children || val, // trigger refresh parent div to change inline width 
      this.state.value !== (_typeof(this.props.children) === 'object' ? this.props.val : this.props.children) && this.setState({
        value: _typeof(this.props.children) === 'object' ? this.props.val : this.props.children
      })));
    }
  }]);

  return FieldRadio;
}(_react.default.Component);

exports.FieldRadio = FieldRadio;
FieldRadio.defaultProps = {
  optionalNode: null,
  children: null,
  cssClass: '',
  doFocus: false,
  isChecked: false,
  handleChange: function handleChange() {}
};
FieldRadio.propTypes = _objectSpread({}, radioPropTypes, {
  optionalNode: _propTypes.default.node,
  cssClass: _propTypes.default.string,
  doFocus: _propTypes.default.bool
});